import { render, staticRenderFns } from "./DefaultTabs.vue?vue&type=template&id=7ac9ede6&"
import script from "./DefaultTabs.vue?vue&type=script&lang=js&"
export * from "./DefaultTabs.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTabs.vue?vue&type=style&index=0&id=7ac9ede6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports